import PropTypes from 'prop-types'
import React from 'react'

import DynamicImage from 'components/DynamicImage'
import RenderInView from 'components/RenderInView'
import { GOODS_TYPES } from 'constants/sales'
import { LocalizationContext } from 'contexts/Localization'
import { BoxBase } from 'styles/components/layout'
import { H1 } from 'styles/components/typography'

import { Content, TextStyled, BaseBoxWrapper } from '../styles'

import { Wrapper, BoxInner } from './styles'

const WAboutCompareFirstMobile = ({ header, text }) => {
  const { dna, wgs } = GOODS_TYPES
  const { paths } = React.useContext(LocalizationContext)

  return (
    <BoxBase overflow="hidden">
      <Wrapper>
        <Content>
          <div className="mb-md-4">
            <H1 as="h2" dangerouslySetInnerHTML={{ __html: header }} />
          </div>
          <TextStyled dangerouslySetInnerHTML={{ __html: text }} />
        </Content>

        <BaseBoxWrapper productType={dna}>
          <BoxInner>
            <RenderInView>
              <DynamicImage
                alt="dna-box-left"
                image={`${paths.cdn_boxes}/dna-left-new`}
                imageSizes={{ xs: 150 }}
                imageType="png"
              />
            </RenderInView>
          </BoxInner>
        </BaseBoxWrapper>
        <BaseBoxWrapper productType={wgs}>
          <BoxInner>
            <RenderInView>
              <DynamicImage
                alt="wgs-box-right"
                image={`${paths.cdn_boxes}/wgs-right-v2`}
                imageSizes={{ xs: 150 }}
                imageType="png"
              />
            </RenderInView>
          </BoxInner>
        </BaseBoxWrapper>
      </Wrapper>
    </BoxBase>
  )
}

WAboutCompareFirstMobile.propTypes = {
  header: PropTypes.string,
  text: PropTypes.string,
}

WAboutCompareFirstMobile.defaultProps = {
  header: '',
  text: '',
}

export default WAboutCompareFirstMobile
